"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const getQuotesBuy_1 = require("../helpers/getQuotesBuy");
const store_1 = require("../context/store");
const useQuotes = (loaded) => {
    const { geoLocation, selectedCrypto: { code }, selectedFiat, fiatValue, debugOptions, } = (0, store_1.useTrackedState)();
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [quotes, setQuotes] = (0, react_1.useState)([]);
    const [loadingStage, setLoadingStage] = (0, react_1.useState)("geo");
    (0, react_1.useEffect)(() => {
        const getData = () => __awaiter(void 0, void 0, void 0, function* () {
            if (!selectedFiat || !fiatValue)
                return;
            const availablePartners = yield (0, getQuotesBuy_1.getAvailableProviders)(geoLocation);
            setLoadingStage("crypto");
            const supportedCryptoPartners = yield (0, getQuotesBuy_1.getCryptoSupportedProviders)((debugOptions === null || debugOptions === void 0 ? void 0 : debugOptions.bypassGeoCheck)
                ? availablePartners.map(() => true)
                : availablePartners, code);
            setLoadingStage("quote");
            const rawQuotes = yield (0, getQuotesBuy_1.getQuotes)(supportedCryptoPartners, code, selectedFiat, fiatValue, geoLocation);
            const sortedQuotes = (0, getQuotesBuy_1.sortQuotes)(rawQuotes, geoLocation);
            setQuotes(sortedQuotes);
            setLoading(false);
        });
        if (loaded) {
            getData();
        }
        else {
            setLoading(true);
            setQuotes([]);
        }
    }, [
        code,
        fiatValue,
        geoLocation,
        loaded,
        selectedFiat,
        debugOptions === null || debugOptions === void 0 ? void 0 : debugOptions.bypassGeoCheck,
    ]);
    return { loading, quotes, loadingStage };
};
exports.default = useQuotes;
//# sourceMappingURL=useQuotesBuy.js.map